import React, { useEffect, useState } from "react";
import { ReturnFilter } from "./components/returnFilter";
import CardHeader from "../../components/atoms/cardHeader";
import { ReturnTable } from "./components/returnTable";
import { Pagination } from "../../components/atoms/pagination";
import { Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { ReturnThunk } from "../../store/thunks/returnThunk";
import CardWrapper from "../../components/molecules/CardWrapper";
import TableLoader from "../../components/atoms/tableLoader";

const Return = ({}) => {
  const {
    list: List,
    loading,
    pageInfo,
    count,
  } = useSelector((state) => state.returnListing);
  const dispatch = useDispatch();
  const [offset, setOffset] = useState(0);
  const [submit, setSubmit] = useState({
    paginationFilter: {
      offset: offset,
      limit: 10,
      order: "DESC",
    },
    returnId: "",
    orderId: "",
    transactionId: "",
    customerName: "",
    toDate: "",
    fromDate: "",
    orderStage: null,
    refundStatus: null,
  });
  useEffect(() => {
    dispatch(
      ReturnThunk({
        orderRequestFilters: submit,
      })
    );
  }, [submit]);

  const tabConfig = [
    {
      key: "1",
      label: "All",
      count: count?.allCounter || 0,
      onClick: () => {
        setSubmit({ ...submit, orderStage: null, refundStatus: null });
      },
    },
    {
      key: "2",
      label: "Return Requested",
      count: count?.returnRequestedCount || 0,
      onClick: () => {
        setSubmit({ ...submit, orderStage: "RETURN", refundStatus: null });
      },
    },
    {
      key: "4",
      label: "Return Cancelled",
      count: count?.returnCancelledCount || 0,
      onClick: () => {
        setSubmit({
          ...submit,
          orderStage: "RETURN_CANCELLED",
          refundStatus: null,
        });
      },
    },
    {
      key: "5",
      label: "Return Initiated",
      count: count?.refundInitiatedCount || 0,
      onClick: () => {
        setSubmit({
          ...submit,
          orderStage: null,
          refundStatus: "REFUND_INITIATED",
        });
      },
    },
    {
      key: "6",
      label: "Refund Pending",
      count: count?.returnPendingCount || 0,
      onClick: () => {
        setSubmit({
          ...submit,
          orderStage: null,
          refundStatus: "REFUND_PENDING",
        });
      },
    },
    {
      key: "3",
      label: "Return Completed",
      count: count?.returnCompleted || 0,
      onClick: () => {
        setSubmit({
          ...submit,
          orderStage: null,
          refundStatus: "REFUND_COMPLETED",
        });
      },
    },
  ];

  return (
    <>
      <div className="content d-flex flex-column flex-column-fluid">
        <div className="container">
          <div className="align-items-center d-flex justify-content-end pb-6">
            <span
              className="btn btn-primary font-weight-bold letter-spacing btn-md ml-5 collapsed"
              data-target="#filter"
              data-toggle="collapse"
            >
              Filter
            </span>
          </div>
        </div>

        {/*Filter Start*/}
        <div className="filter_area collapse" id="filter">
          <div className="container">
            <CardHeader name="Return Filter"/>
            <ReturnFilter submit={submit} setSubmit={setSubmit} />
          </div>
        </div>
        {/*Filter End*/}

        <CardWrapper>
          <CardHeader name={"Return"} tooltipText={"Track and manage all return and refund activities."}/>

          <div className="card-body p-4">
            <Tabs defaultActiveKey="1">
              {tabConfig.map(({ key, label, count, onClick }) => (
                <div
                  key={key}
                  className="w-100"
                  tab={
                    <span onClick={onClick}>
                      {label} ({count})
                    </span>
                  }
                >
                  <>{loading ? <TableLoader /> : <ReturnTable list={List} />}</>
                </div>
              ))}
            </Tabs>
            <Pagination
              pageInfo={pageInfo}
              offset={submit.paginationFilter.offset}
              setOffset={(newOffset) =>
                setSubmit((prev) => ({
                  ...prev,
                  paginationFilter: {
                    ...prev.paginationFilter,
                    offset: newOffset,
                  },
                }))
              }
            />
          </div>
        </CardWrapper>
      </div>
    </>
  );
};

export default Return;
